import $ from 'jquery';
import { AccountsGrid } from './accounts-grid';
import { getConfig } from './accounts-grid-config';
import { getAdsPlugins } from './plugins/index';

export function createAccountsGridView({
  i18n,
  gridType,
  el, // For OldUI only
  preferenceConfig,
  parentPerfMarker,
  addDateChangeListener,
  viewport,
  filterService,
  getAdditionalPlugins = () => [],
  isForVNext = false,
  getAdditionalEvents = () => ({}),
  p$daterange,
  pageName,
  scope,
  preexecuteFlag = false,
  hasUnifiedSmartAccount = false,
  permissions,
}) {
  return new AccountsGrid({
    el,
    gridType,
    preferenceConfig,
    filterService,
    pageName,
    isForVNext,
    getGridConfig: view => getConfig({
      view,
      gridType,
      preferenceConfig,
      viewport,
      filterService,
      isForVNext,
      preexecuteFlag,
      hasUnifiedSmartAccount,
      additionalEvents: getAdditionalEvents(view),
      customHeaderOffset: () => $('.sticky-container').height(),
      permissions,
      i18n,
    }),
    getPlugins: view => getAdsPlugins({
      view,
      gridType,
      preferenceConfig,
      viewport,
      parentPerfMarker,
      addDateChangeListener,
      filterService,
      isForVNext,
      p$daterange,
      scope,
      hasUnifiedSmartAccount,
    }).concat(getAdditionalPlugins(view)),
  });
}
